/** @format */
import { css } from 'styled-components';

import { CarouselModalProps } from './types';

const baseStyles = css`
    .button {
        &.full-screen {
            display: none;
        }
    }
`;

export const styles = (props: CarouselModalProps) => css`
    ${baseStyles}
`;
